import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { Box } from "@mui/material";
import FilterCard from "./FilterCard";

const Cards = ({
  width,
  data = [],
  title,
  onFilterChange,
  flexwrap,
  setSelectedMonth,
  setSelectedYear,
  selectedMonth,
  selectedYear,
}) => {
  const [selectedFilters, setSelectedFilters] = useState({});
  useEffect(() => {
    if (!data || data.length === 0) return;
    const initialFilters = data.reduce((acc, item) => {
      if (item?.filter === "option" && item?.filterValues?.length > 0) {
        acc[item.key] = item.defaultValue || item.filterValues[0];
      } else if (item?.filter === "date") {
        acc[item.key] = dayjs().format("YYYY-MM");
      }
      return acc;
    }, {});
    setSelectedFilters(initialFilters);
  }, []);

  const handleSelect = (key, value, filterType) => {
    setSelectedFilters((prev) => {
      const updatedFilters = { ...prev, [key]: value };

      if (JSON.stringify(prev) !== JSON.stringify(updatedFilters)) {
        onFilterChange?.(key, value, filterType);
        return updatedFilters;
      }
      return prev;
    });
  };


  return (
    <>
      <p
        style={{
          fontWeight: "700",
          fontSize: "22px",
          color: "#001632",
          fontFamily: "Inter",
          textDecoration: "underline",
          marginTop: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        {title}
      </p>
      <Box
        sx={{
          display: "flex",
          flexWrap: flexwrap === "no" ? "" : "wrap",
          gap: "1rem",
          justifyContent: "space-between",
        }}
      >
        {data.map((item, idx) => (
          <FilterCard
            key={idx}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
              width,
            }}
            item={item}
            selectedValue={selectedFilters?.[item.key] || ""}
            handleSelect={handleSelect}
          />
        ))}
      </Box>
    </>
  );
};

export default Cards;
